import { useEffect, useRef, useState } from "react";
import { AppUtils } from "../../../../../../utils/appUtils";
import { API_URL } from "../../../../../../api/api";
import { getDataFromServer } from "../../../../../../utils/apiUtils";
import { Box, Card, CardContent, Divider, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { AppMisc } from "../../../../../../misc/appMisc";
import { Delete, Edit } from "@mui/icons-material";
import CustomPagination from "../../../../../../components/custom-pagination/CustomPagination";
import { GENDER_OPTIONS, NO_RECORDS_FOUND } from "../../../../../../utils/constants";


const YogSewaBibaranRegister = ({ page, totalSize, ...props }) => {
  const [mainRegisterData, setMainRegisterData] = useState([]);
  const tableRef = useRef();
  const id = AppUtils.getUrlParam("id");
  const [cardData, setCardData] = useState([]);

  useEffect(() => {
    if (props.tableData !== null) {
      setMainRegisterData(props.tableData);
    }
  }, [props.tableData]);



  const getCardData = async () => {
    let url = API_URL.yogSewaRegister + "/" + id
    let response = await getDataFromServer(url)
    if (response) {
      setCardData(response)
    }
  }

  useEffect(() => {
    getCardData()
  }, [])

  return (
    <>
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle1">सेवाग्राहीको सामान्य विवरण</Typography>
              <Divider />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              दर्ता मिति:{AppMisc.getDateLabelFromMillisecond(cardData?.dartaaMiti)}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              नाम:{cardData?.patientFirstName}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              थर:{cardData?.patientLastName}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              उमेर:{cardData?.age && AppUtils.replaceWithNepaliDigit(cardData.age)}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              लिङ्ग:{cardData?.gender && AppMisc.findLabelFromValue(GENDER_OPTIONS, cardData.gender)}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              जिल्ला:{cardData?.district && AppMisc.getDistrictName(cardData.district)}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              नगर/गाउँपालिका:{cardData?.palikaName}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              वडा नं:{cardData?.wardNumber && AppUtils.replaceWithNepaliDigit(cardData.wardNumber)}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              टोल:{cardData?.gaunOrTole}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              सम्पर्क नं.:{cardData?.phoneNumber && AppUtils.replaceWithNepaliDigit(cardData?.phoneNumber)}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <TableContainer classes={{ root: "fixed-head-table-container" }} ref={tableRef}>
        <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Mul Dartaa Register">
          <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
            <TableRow>
              <TableCell rowSpan={2}>मिति</TableCell>
              <TableCell rowSpan={2}>थेरापी</TableCell>
              <TableCell rowSpan={2}>विवरण</TableCell>
              <TableCell rowSpan={2}>सेवा</TableCell>
              <TableCell rowSpan={2}>जटिलता</TableCell>
              <TableCell rowSpan={2}>परीक्षण /सल्लाह</TableCell>
              <TableCell rowSpan={2}>सम्पादन</TableCell>
            </TableRow>
          </TableHead>
          <TableBody classes={{ root: "align-center" }}>
            {mainRegisterData?.length > 0 ? (
              mainRegisterData?.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{AppMisc.getDateLabelFromMillisecond(row?.date)}</TableCell>
                  <TableCell>{row?.therapy}</TableCell>
                  <TableCell>{row.treatmentDetails || "-"}</TableCell>
                  <TableCell>{row.service || "-"}</TableCell>
                  <TableCell>{row.complication || "-"}</TableCell>
                  <TableCell>{row.testing || "-"}</TableCell>
                  <TableCell>
                    <Box display="flex" alignItems="center">
                      <IconButton aria-label="edit" onClick={() => props.onEditRow(row.id)}>
                        <Edit fontSize="small" />
                      </IconButton>
                      <Tooltip title="रेकर्ड हटाउन यहा क्लिक गर्नुहोस" placement="top" arrow>
                        <IconButton color="secondary" onClick={() => props.deleteRow(row.id)}>
                          <Delete fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan="8" size="medium">{NO_RECORDS_FOUND}</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomPagination count={totalSize} />
    </>
  );
};

export default YogSewaBibaranRegister;